export const transient = (props)=>Object.entries(props).reduce((transientProps, [key, value])=>{
        transientProps[`$${key}`] = value;
        return transientProps;
    }, {});

//# sourceMappingURL=index.js.map